<template>
  <div class="projects-page">

    <!-- Верхняя панель -->
    <div class="header-row">
      <h1>Проекты</h1>

      <div class="right-tools">
        <select v-model="filterBot" class="filter-select">
          <option value="">Все боты</option>
          <option v-for="b in bots" :value="b.id" :key="b.id">
            @{{ b.username }}
          </option>
        </select>

        <button class="btn-primary" @click="openCreateForm">
          + Создать проект
        </button>
      </div>
    </div>

    <!-- СПИСОК ПРОЕКТОВ -->
    <div class="projects-list">

      <div
          class="project-item"
          :class="{ expanded: expandedProjectId === project.id }"
          v-for="(project, index) in filteredProjects"
          :key="project.id"
          draggable="true"
          @dragstart="dragStart(index)"
          @dragover.prevent
          @drop="drop(index)"
          @click="toggleExpand(project.id)"
      >

        <!-- ПЕРВАЯ СТРОКА -->
        <div class="row-top">

          <!-- ТУТ БЫЛО НАЗВАНИЕ — СЕЙЧАС TELEGRAM PREVIEW -->
          <span class="name-preview">{{ renderTelegram(project) }}</span>

          <div class="bots-inline">
            <span class="bot-count">🤖 Ботов: {{ project.bots.length }}</span>
          </div>

          <div class="actions-block" @click.stop>
            <button class="icon-btn edit" @click="openEditForm(project)">✏️</button>
            <button class="icon-btn delete" @click="deleteProject(project.id)">✖</button>
          </div>
        </div>

        <!-- ДЕТАЛИ -->
        <div v-if="expandedProjectId === project.id" class="details-block">

          <p><b>Боты:</b></p>
          <div class="bots-detailed">
            <span v-for="bot in project.bots" :key="bot.id" class="bot-chip">
              @{{ bot.username }}
            </span>
          </div>

          <p><b>Промокод текст:</b> {{ project.promocode }}</p>
          <p><b>Бонус текст:</b> {{ project.bonus_text }}</p>
          <p><b>Ссылка:</b> <a :href="project.url" target="_blank">{{ project.url }}</a></p>
          <p><b>Активен:</b> {{ project.is_active ? "Да" : "Нет" }}</p>
        </div>

      </div>

    </div>

    <!-- МОДАЛКА -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-window">

        <h2>{{ editMode ? "Изменить проект" : "Новый проект" }}</h2>

        <div class="form-grid">

          <label>Название</label>
          <input v-model="form.name" type="text">

          <label>Emoji</label>
          <input v-model="form.emoji" type="text">

          <label>Промокод</label>
          <input v-model="form.promocode" type="text">

          <label>Бонус текст</label>
          <input v-model="form.bonus_text" type="text">

          <label>Ссылка</label>
          <input v-model="form.url" type="text">

          <label class="checkbox-label">
            <input type="checkbox" v-model="form.is_active">
            Активен
          </label>

          <label>Привязанные боты</label>
          <div class="bots-selector">
            <label v-for="bot in bots" :key="bot.id">
              <input type="checkbox" :value="bot.id" v-model="form.bot_ids">
              @{{ bot.username }}
            </label>
          </div>

        </div>

        <div class="modal-actions">
          <button class="btn-primary" @click="saveProject">Сохранить</button>
          <button class="btn-secondary" @click="closeModal">Отмена</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { API_URL } from "@/config";

export default {
  name: "Projects",

  data() {
    return {
      projects: [],
      bots: [],

      filterBot: "",
      dragIndex: null,
      expandedProjectId: null,

      showModal: false,
      editMode: false,

      form: {
        id: null,
        name: "",
        emoji: "",
        promocode: "",
        bonus_text: "",
        url: "",
        is_active: true,
        bot_ids: [],
      }
    };
  },

  async created() {
    await this.loadProjects();
    await this.loadBots();
  },

  computed: {
    filteredProjects() {
      if (!this.filterBot) return this.projects;
      return this.projects.filter(p => p.bots.some(b => b.id === this.filterBot));
    }
  },

  methods: {
    /* === Генерация строки как в Telegram === */
    renderTelegram(p) {
      let parts = [];

      if (p.emoji) parts.push(p.emoji);
      if (p.name) parts.push(p.name);

      if (p.promocode)
        parts.push("➜ 🎁 ПРОМО: " + p.promocode);

      if (p.bonus_text)
        parts.push("➜ " + p.bonus_text);


      return parts.join(" ");
    },

    toggleExpand(id) {
      this.expandedProjectId = this.expandedProjectId === id ? null : id;
    },

    async loadProjects() {
      this.projects = await fetch(`${API_URL}/projects`).then(r => r.json());
    },

    async loadBots() {
      this.bots = await fetch(`${API_URL}/bots`).then(r => r.json());
    },

    dragStart(index) {
      this.dragIndex = index;
    },

    async drop(toIndex) {
      const fromIndex = this.dragIndex;
      if (fromIndex === toIndex) return;

      const moved = this.projects.splice(fromIndex, 1)[0];
      this.projects.splice(toIndex, 0, moved);

      await this.updateOrder();
    },

    async updateOrder() {
      const ordered = this.projects.map((p, index) => ({
        id: p.id,
        priority: index,
      }));

      await fetch(`${API_URL}/projects/reorder`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(ordered),
      });
    },

    openCreateForm() {
      this.editMode = false;
      this.form = {
        id: null,
        name: "",
        emoji: "",
        promocode: "",
        bonus_text: "",
        url: "",
        is_active: true,
        bot_ids: [],
      };
      this.showModal = true;
    },

    openEditForm(project) {
      this.editMode = true;
      this.form = {
        id: project.id,
        name: project.name,
        emoji: project.emoji,
        promocode: project.promocode,
        bonus_text: project.bonus_text,
        url: project.url,
        is_active: project.is_active,
        bot_ids: project.bots.map(b => b.id),
      };
      this.showModal = true;
    },

    async saveProject() {
      const payload = { ...this.form };

      if (this.editMode) {
        await fetch(`${API_URL}/projects/${payload.id}`, {
          method: "PUT",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify(payload),
        });
      } else {
        await fetch(`${API_URL}/projects`, {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify(payload),
        });
      }

      this.closeModal();
      await this.loadProjects();
      await this.updateOrder();
    },

    async deleteProject(id) {
      if (!confirm("Удалить проект?")) return;

      await fetch(`${API_URL}/projects/${id}`, { method: "DELETE" });

      await this.loadProjects();
      await this.updateOrder();
    },

    closeModal() {
      this.showModal = false;
    }
  }
};
</script>

<style scoped>
.projects-page {
  max-width: 900px;
  padding: 20px;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.right-tools {
  display: flex;
  gap: 10px;
  align-items: center;
}

.filter-select {
  padding: 6px 10px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
}

/* 🔹 КНОПКА "СОЗДАТЬ ПРОЕКТ" — меньше и аккуратнее */
.btn-primary {
  background: #4a8eff;
  border: none;
  padding: 7px 12px;
  color: white;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: 0.15s;
}

.btn-primary:hover {
  background: #3a7be6;
}

.btn-secondary {
  background: #e2e2e2;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

/* LIST */
.projects-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.project-item {
  background: #f8f9fb;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: 0.15s;
}

.project-item:hover {
  background: #f2f4f7;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.row-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Telegram preview text */
.name-preview {
  font-size: 14px;
  font-weight: 500;
  color: #1e1e1e;
  max-width: 360px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* BOTS */
.bots-inline {
  margin-left: auto;
}

.bot-count {
  font-size: 11px;
  background: #e7f1ff;
  padding: 3px 7px;
  border-radius: 6px;
  border: 1px solid #c9dcff;
  color: #2f5fae;
  white-space: nowrap;
}

/* Buttons */
.actions-block {
  display: flex;
  gap: 6px;
  margin-left: 10px;
}

.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 15px;
  opacity: 0.6;
  transition: 0.1s;
}

.icon-btn:hover {
  opacity: 1;
}

.icon-btn.delete {
  color: #e64545;
}

/* DETAILS */
.details-block {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #dcdcdc;
  font-size: 13px;
}

.bots-detailed {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;
}

.bot-chip {
  background: #eef5ff;
  padding: 3px 7px;
  border-radius: 6px;
  border: 1px solid #cddfff;
  color: #295fa4;
  font-size: 11px;
}

/* MODAL */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-window {
  width: 420px;
  background: white;
  padding: 25px;
  border-radius: 12px;
  animation: popup 0.2s ease-out;
}

@keyframes popup {
  from { opacity:0; transform: scale(0.9); }
  to   { opacity:1; transform: scale(1); }
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-grid input {
  padding: 9px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.bots-selector {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  max-height: 150px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
}

.modal-window {
  width: 420px;
  max-height: 80vh;         /* ограничиваем высоту экрана */
  overflow-y: auto;          /* включаем вертикальный скролл */
  background: white;
  padding: 25px;
  border-radius: 12px;
  animation: popup 0.2s ease-out;
  box-sizing: border-box;
}

/* Чтобы скролл был аккуратный */
.modal-window::-webkit-scrollbar {
  width: 6px;
}

.modal-window::-webkit-scrollbar-thumb {
  background: #c7c7c7;
  border-radius: 4px;
}

.modal-window::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>

